module.exports = __webpack_public_path__ + "img/Sammelplatz_für_betroffene.b0a52e43.svg";